module.exports = __webpack_public_path__ + "static/media/Matheson Street, Healdsburg, CA2.06034268.jpg";